var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodingBw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 104.786,
    width: 84.532,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 3.32876849,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M1.664 1.664h81.204v101.457H1.664z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.922 14.798h83.3",
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 0.84079602,
      stroke: "#161616",
      strokeWidth: 2.16530228,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.111,
    cy: 8.842,
    cx: 9.145,
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 0.37795275,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 0.37795275,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    cx: 16.492,
    cy: 8.842,
    r: 2.111
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.111,
    cy: 8.842,
    cx: 23.84,
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 0.37795275,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "12.56318092px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 0.31407952,
      strokeOpacity: 1
    },
    "aria-label": "</>"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontFamily: "Ubuntu",
      InkscapeFontSpecification: "Ubuntu",
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 0.31407952,
      strokeOpacity: 1
    },
    d: "m218.622 134.359 4.46 1.834-.327.967-5.427-2.299v-1.005l5.427-2.299.327.967zm6.024 6.081h-1.194l4.259-12.162h1.168zm4.607-7.916.327-.967 5.427 2.3v1.004l-5.427 2.3-.327-.968 4.46-1.834z",
    transform: "translate(-812.54 -453.42) scale(3.77953)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodingBw);
export default __webpack_public_path__ + "static/media/CodingBW.3da8e23234e5a27ccc82c2f5b5d08dd9.svg";
export { ForwardRef as ReactComponent };